<template>
    <div class="peoplelist">
        <el-form :inline="true" :model="query">
            <el-form-item label="">
                <el-input class="search-el" size="mini" v-model="query.consumer_name" clearable placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-input class="search-el" size="mini" v-model="query.consumer_phone" clearable placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-input class="search-el" size="mini" v-model="query.consumer_region" clearable placeholder="请输入城市"></el-input>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker size="mini" v-model="query.begin_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="开始日期"></el-date-picker>~
                <el-date-picker size="mini" v-model="query.end_at" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" type="datetime"
                                placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
            </el-form-item>
        </el-form>
        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 10px 0">
                <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>
                <el-table-column label="姓名" align="center" min-width="8%">
                    <template slot-scope="{ row }">
                        <div>{{ row.consumer_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="手机号" align="center" min-width="20%">
                    <template slot-scope="{ row }">
                        {{row.consumer_phone}}
                    </template>
                </el-table-column>
                <el-table-column label="城市" align="center" min-width="8%">
                    <template slot-scope="{ row }">
                        <div>{{ row.consumer_region }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="提交时间" align="center" min-width="12%">
                    <template slot-scope="{ row }">
                        <div>{{row.created_at }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" min-width="12%">
                    <template slot-scope="{ row }">
                        <div>{{row.remark }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="12%">
                    <template slot-scope="{ row }">
                        <el-button type="text" @click="openremarkHandel(row.id)">添加备注</el-button>
                        <el-button type="text" @click="deleteHandel(row.id)" style="color: red;"> 删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog :visible.sync="dialogTableVisible" center :before-close="handleClose">
            <el-form>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clossdialogTableVisible">取 消</el-button>
                <el-button type="primary" @click="submitremark">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getconsumerlist,
    updateconsumerinfo,
    delteconsumerinfo,
} from "@/api/yxs";
import flashSaleCourseAddVue from '../promotion/flashSaleCourseAdd.vue';
export default {
    name: "",
    data() {
        return {
            query: {
                id: "",
                consumer_name: "",
                consumer_phone: "",
                consumer_region: "",
                begin_at: "",
                end_at: "",
                limit: 20,
                page: 1,
            },
            remark: "",
            total: 0,
            list: [],
            loading: false,
            dialogTableVisible: false,
            remarkid: 0,
        };
    },
    components: {},
    created() {
        this.query.id = this.$route.query.id;
    },
    mounted() {
        this.getList();
    },
    methods: {
        deleteHandel(id) {
            this.$confirm("此操作将删除该对象，是否继续？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    delteconsumerinfo({ id: id })
                        .then((res) => {
                            if (res.code) {
                                this.getList();
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success",
                                });
                            }
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        submitremark() {
            updateconsumerinfo({ id: this.remarkid,remark:this.remark }).then((res) => {
                if (res.code) {
                  this.getList();
                    this.$message({
                        showClose: true,
                        message: "添加成功",
                        type: "success",
                    });
                    this.dialogTableVisible = false
                }
            });
        },
        clossdialogTableVisible() {
            this.dialogTableVisible = false;
            this.remark = "";
        },
        handleClose(){
          this.clossdialogTableVisible()
        },
        openremarkHandel(id) {
            this.dialogTableVisible = true;
            this.remarkid = id;
        },
        getList() {
          console.log(this.query.page);
          
            getconsumerlist(this.query).then((res) => {
                this.loading = true;
                if (res.code) {
                    this.loading = false;
                    this.list = res.data.list;
                    this.total = res.data.total;
                    if (this.query.page > Math.ceil(this.total / this.query.limit)) {
                    this.query.page = 1;
                    this.fetchData();
                  }
                    console.log(this.query.page,'2');
                    
                }

            });
        },
        fetchData(){
          this.getList()
        },
    },
};
</script>

<style>
.peoplelist .el-dialog .el-dialog__body {
    padding: 0 20px 30px !important;
}
</style>
